import type { Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { authGuard } from './core/services/guard/auth.guard';
import { PrimaryLayoutComponent } from './core/layout/primary-layout/primary-layout.component';

function makeMemberAreaRoutes(routes: Routes): Routes {
  return [
    {
      path: '',
      component: PrimaryLayoutComponent,
      canActivate: [authGuard],
      canActivateChild: [authGuard],
      children: [...routes],
    },
  ];
}

const ANONYMOUS_ROUTES = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then((mod) => mod.LoginComponent),
    data: {
      label: 'ログイン',
    },
  },
  {
    path: 'link-login',
    loadComponent: () => import('./pages/link-login/link-login.component').then((mod) => mod.LinkLoginComponent),
    data: {
      label: 'ログイン',
    },
  },
  {
    path: 'login-announcement',
    loadComponent: () => import('./pages/login-announcement/login-announcement.component').then((mod) => mod.LoginAnnouncementComponent),
    data: {
      label: 'ログイン',
    },
  },
  {
    path: 'membership-application',
    loadComponent: () =>
      import('./pages/membership-application/membership-application.component').then((mod) => mod.MembershipApplicationComponent),
    data: {
      label: '会員登録',
    },
  },
  {
    path: 'membership-application-complete',
    loadComponent: () =>
      import('./pages/membership-application-complete/membership-application-complete.component').then(
        (mod) => mod.MembershipApplicationCompleteComponent,
      ),
    data: { label: '会員登録' },
  },
];

const MEMBER_ROUTES = makeMemberAreaRoutes([
  {
    path: '',
    loadComponent: () => import('./pages/bulletin-board/bulletin-board.component').then((mod) => mod.BulletinBoardComponent),
    data: { label: 'ホーム' },
  },
  {
    path: 'dashboard',
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then((mod) => mod.DashboardComponent),
        data: { label: 'マイページ' },
      },
    ],
  },
  {
    path: 'product-detail/:productId',
    loadComponent: () => import('./pages/product-detail/product-detail.component').then((mod) => mod.ProductDetailComponent),
    data: { label: '作品詳細' },
  },
  {
    path: 'transaction-detail/:transactionId',
    loadComponent: () => import('./pages/transaction-detail/transaction-detail.component').then((mod) => mod.TransactionDetailComponent),
    data: { label: '取引詳細' },
  },
  {
    path: 'managed-product',
    loadComponent: () => import('./pages/managed-product/managed-product.component').then((mod) => mod.ManagedProductComponent),
    data: { label: '作品管理' },
  },
  {
    path: 'product-register',
    loadComponent: () => import('./pages/product-register/product-register.component').then((mod) => mod.ProductRegisterComponent),
    data: { label: '作品出品' },
  },
  {
    path: 'product-register/:productId',
    loadComponent: () => import('./pages/product-register/product-register.component').then((mod) => mod.ProductRegisterComponent),
    data: { label: '作品出品' },
  },
  {
    path: 'notification',
    loadComponent: () => import('./pages/notification/notification.component').then((mod) => mod.NotificationComponent),
    data: { label: 'お知らせ一覧' },
  },
  {
    path: 'product-request-register',
    loadComponent: () => import('./pages/product-request-register/product-request-register.component'),
  },
  {
    path: 'product-request-register/:productRequestId',
    loadComponent: () => import('./pages/product-request-register/product-request-register.component'),
  },
  {
    path: 'product-request-detail/:productRequestId',
    loadComponent: () => import('./pages/product-request-detail/product-request-detail.component'),
  },
]);

const DEBUG_ROUTES = (() => {
  if (environment.productionMode) {
    // productionModeではデバッグ用のRouteは無効にする
    return [];
  }
  return [
    // 開発でのみ使用するRouteはここに追加してください
  ];
})();

export const routes = [...ANONYMOUS_ROUTES, ...MEMBER_ROUTES, ...DEBUG_ROUTES, { path: '**', redirectTo: '/' }];
